export const exhibitionOptions = [
  { label: 'Exibir proprietário', name: 'boExibirProprietario' },
  { label: 'Exibir acessibilidade', name: 'boExibirAcessibilidade' },
  { label: 'Exibir situação', name: 'boExibirSituacao' },
];

export const utilizationOptions = [
  {label: "Nenhum", value: null},
  { label: 'Sistema', value: 'Sistema' },
  { label: 'Serviços especiais', value: 'Serviços especiais' },
];

export const inspectionResultsExhibitionOptions = [
  { label: 'Aprovados', name: 'boVistoriaExibirAprovados' },
  { label: 'Reprovados', name: 'boVistoriaExibirReprovados' },
  { label: 'À realizar', name: 'boVistoriaExibirRealizar' },
];

export const inspectionRequestStatusExhibitionOptions = [
  { label: 'Com certificado', name: 'boVistoriaExibirCertificados' },
  { label: 'Sem certificado', name: 'boVistoriaExibirNaoCertificados' },
];

export const groupingByOptions = [
  { label: 'Sem agrupamento', value: null },
  { label: 'Agrupar por operador', value: 1 },
];